
import React from "react";
import { Button } from "@/components/ui/button";
import AuthForm from "@/components/checkout/AuthForm";

interface AuthSectionProps {
  user: any;
  showAuthForm: boolean;
  onShowAuth: () => void;
  onAuthSuccess: () => void;
}

const AuthSection = ({ 
  user, 
  showAuthForm, 
  onShowAuth, 
  onAuthSuccess 
}: AuthSectionProps) => {
  if (user) return null;
  
  return (
    <div className="mb-8">
      {!showAuthForm ? (
        <div className="p-5 border border-gray-200 rounded-lg mb-6">
          <h3 className="text-lg font-medium mb-2">Loo konto või logi sisse</h3>
          <p className="mb-4 text-gray-600">Sul on vaja kontot, et kursusele ligi pääseda</p>
          <Button 
            onClick={onShowAuth}
            className="w-full mb-3 bg-kaija-accent hover:bg-opacity-90 text-white"
          >
            Jätka kontoga
          </Button>
        </div>
      ) : (
        <AuthForm onSuccess={onAuthSuccess} />
      )}
    </div>
  );
};

export default AuthSection;
